<template>
  <button
      :class="{ 'bg-cal-81B920 text-white': !invert, 'bg-white text-cal-81B920': invert, 'uppercase': uppercase }"
      class="px-4 py-3 text-sm flex justify-between items-center space-x-2"
      type="button"
  >
    <span class="w-3" :class="{ 'fill-white': !invert, 'fill-cal-81B920': invert }">
      <slot name="icon"></slot>
    </span>
    <span><slot name="label"></slot></span>
  </button>
</template>
<script>
export default {
  name: 'IconButton',
  props: {
    invert: {
      type: Boolean,
      default: false,
    },
    uppercase: {
      type: Boolean,
      default: false,
    }
  }
}
</script>
